import isThankYouStep from './isThankYouStep';

export default isThankYouStep;
